import { render } from "./index.vue?vue&type=template&id=6de33270&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=6de33270&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de33270"]])

export default __exports__